document.addEventListener('DOMContentLoaded', () => {
  // obecne
  let bodyWidth = window.innerWidth;

  // události při resize okna
  window.addEventListener('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });
  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if (document.querySelector('.nav-switcher').classList.contains('is-open')) {
      document.querySelector('.nav-switcher').classList.remove('is-open');
      document.querySelector('.nav').classList.remove('is-open');
      document.body.classList.remove('is-unscrollable');
    } else {
      document.querySelector('.nav-switcher').classList.add('is-open');
      document.querySelector('.nav').classList.add('is-open');
      document.body.classList.add('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    document.querySelector('.nav-switcher').classList.remove('is-open');
    document.querySelector('.nav').classList.remove('is-open');
    document.body.classList.remove('is-unscrollable');
  }

  // light/dark theme přepínač
  function switchTheme() {
    // označíme zda je menu zavřeno či nikoliv
    if (document.querySelector('html').classList.contains('dark-theme')) {
      document.querySelector('html').classList.remove('dark-theme');
      resetMenu();
    } else {
      document.querySelector('html').classList.add('dark-theme');
      resetMenu();
    }
  }

  // spouštěč
  document.querySelector('.nav-switcher').addEventListener('click', function () {
    switchMenu();
  });

  document.querySelectorAll('.theme-switcher').forEach((element) => {
    element.addEventListener('click', function () {
      switchTheme();
    });
  });

  // události při načtení stránky
  window.addEventListener('load', function () {
    // AOS fix pro první načítání
    AOS.refresh();
  });

  // události při scroolování
  window.addEventListener('scroll', function () {
    //...
  });

  // modal okna
  if (document.querySelector('.modal')) {
    modal();
  }

  // slider
  if (document.querySelector('.slider')) {
    const slider = new Glider(document.querySelector('.slider'), {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      dots: '.slider__dots',
      scrollLock: true,
      scrollLockDelay: 0,
      rewind: true,
    });
    gliderAutoplay(slider, { interval: 6000 });
  }

  // faq
  if (document.querySelector('.faq')) {
    faqQuestion = document.getElementsByClassName('faq__question');
    for (i = 0; i < faqQuestion.length; i++) {
      faqQuestion[i].addEventListener('click', function () {
        if (this.closest('.faq__item').classList.contains('is-open')) {
          this.closest('.faq__item').classList.remove('is-open');
        } else {
          this.closest('.faq__item').classList.add('is-open');
        }
      });
    }
  }

  // galerie
  if (document.querySelector('.gallery')) {
    new SimpleLightbox('.gallery a', {
      showCounter: false,
    });
  }
});
